import api from './api';

// An issued invoice as its PDF -- the invoice and its two delivery notes -- in
// a new tab. The tab opens on the click, before the PDF is made, so the browser
// does not take it for a pop-up. Invoices and the Invoice button on Orders.
export async function openInvoicePdf(inv, toast) {
  const w = window.open('', '_blank');
  try {
    const r = await api.get(`/api/v1/invoices/${inv.id}/pdf`, { responseType: 'blob' });
    const url = URL.createObjectURL(new Blob([r.data], { type: 'application/pdf' }));
    if (w) w.location = url; else window.location.href = url;
  } catch {
    if (w) w.close();
    toast.error(`The PDF of ${inv.number} could not be made just now.`);
  }
}
